import { BaseDto } from '@/shared/dtos/base-dto';

export class permiso extends BaseDto {
    public nombre !: string;
    public id_rol !: number;
 } 
